(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("binaryen"), (function webpackLoadOptionalExternalModule() { try { return require("assemblyscript"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["binaryen", "assemblyscript"], factory);
	else if(typeof exports === 'object')
		exports["asc"] = factory(require("binaryen"), (function webpackLoadOptionalExternalModule() { try { return require("assemblyscript"); } catch(e) {} }()));
	else
		root["asc"] = factory(root["binaryen"], root["assemblyscript"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__725__, __WEBPACK_EXTERNAL_MODULE__474__) {
return 